export default __webpack_public_path__ + "static/media/instructor1.8ed25998.jpg";